import React, { useState } from 'react'
import { Input, Select, Button, Card, Row, Col, Space } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch, faXmark, faUser } from '@fortawesome/free-solid-svg-icons'
import {ExportExcel} from './ExportExcel'
const { Option } = Select

export const ParticipantesFilters = ({ onFilterChange, onCreateClick, filteredParticipantes,  loading = false, permissionInsert, permissionExport }) => {
    const [filters, setFilters] = useState({
        search: '',
        cohorte: '',
        activo: '',
        certificado: ''
    })

    const handleFilterChange = (key, value) => {
        const newFilters = { ...filters, [key]: value }
        setFilters(newFilters)
        onFilterChange(newFilters)
    }

    const clearFilters = () => {
        const clearedFilters = {
            search: '',
            cohorte: '',
            activo: '',
            certificado: ''
        }
        setFilters(clearedFilters)
        onFilterChange(clearedFilters)
    }

    const hasActiveFilters = Object.values(filters).some(value => value !== '')

    return (
        <Card style={{ marginBottom: '1.5rem', padding: '1.5rem' }}>
            <Row gutter={[16, 16]} align="middle" justify="start">
                <Col xs={24} md={8}>
                    <Input
                        prefix={<FontAwesomeIcon icon={faSearch} className="text-gray-400" />}
                        placeholder="Buscar por nombre, identificación"
                        value={filters.search}
                        onChange={(e) => handleFilterChange('search', e.target.value)}
                        allowClear
                    />
                </Col>
                <Col xs={24} sm={8} md={4}>
                    <Select
                        value={filters.cohorte || undefined}
                        onChange={(value) => handleFilterChange('cohorte', value)}
                        placeholder="Cohorte"
                        style={{ width: '100%' }}
                        allowClear
                    >
                        <Option value="1">Cohorte 1</Option>
                        <Option value="2">Cohorte 2</Option>
                        <Option value="3">Cohorte 3</Option>
                    </Select>
                </Col>
                <Col xs={24} sm={8} md={4}>
                    <Select
                        value={filters.activo || undefined}
                        onChange={(value) => handleFilterChange('activo', value)}
                        placeholder="Estado"
                        style={{ width: '100%' }}
                        allowClear
                    >
                        <Option value="Si">Activo</Option>
                        <Option value="No">Inactivo</Option>
                    </Select>
                </Col>
                <Col xs={24} sm={8} md={4}>
                    <Select
                        value={filters.certificado || undefined}
                        onChange={(value) => handleFilterChange('certificado', value)}
                        placeholder="Certificado"
                        style={{ width: '100%' }}
                        allowClear
                    >
                        <Option value="Si">Certificado</Option>
                        <Option value="No">Sin certificar</Option>
                    </Select>
                </Col>
                <Col xs={24} md={4}>
                    <Space wrap>
                        {hasActiveFilters && (
                            <Button
                                onClick={clearFilters}
                                style={{ minWidth: 180 }}
                            >
                                <FontAwesomeIcon icon={faXmark} className="mr-2" />
                                Limpiar
                            </Button>
                        )}
                        {permissionExport && <ExportExcel participantes={filteredParticipantes} loading={loading} />}
                        {permissionInsert && (
                        <Button
                            type="primary"
                            onClick={onCreateClick}
                            style={{ minWidth: 180 }}
                        >
                            <FontAwesomeIcon icon={faUser} className="mr-2" />
                            Crear Participante
                        </Button>)}
                    </Space>
                </Col>
            </Row>
        </Card>
    )
}

export default ParticipantesFilters
